window.invisibleRecaptchaSubmit = function(_token) {
	$('.invisible_recaptcha_form').trigger('submit')
}
